import { HttpParams } from '@angular/common/http'
import { Component, effect, input, output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { ComboBox } from '@grapecity/wijmo.input'

import { BaseComponent, Grid, ListItem, PartsFluidsItem } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-parts-fluids-by-equipment',
    templateUrl: './parts-fluids-by-equipment.component.html',
    styleUrls: ['./parts-fluids-lookup.component.css'],
    standalone: true,
    imports: [
        FormsModule,
        RouterLink,
        WjInputModule,
        WjGridModule,
        WjGridFilterModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        AutoSizeDirective,
    ],
})
export class PartsFluidsByEquipmentComponent extends BaseComponent {
    equipmentOptions = input<ListItem<string>[]>([])
    selectedEquipment = input('')
    selectedEquipmentChange = output<string>()
    selectedItemChange = output<string>()

    grid: Grid<PartsFluidsItem>
    private equipmentCombo: ComboBox | null = null
    private applyingSelection = false
    private lastLoadedEquipment: string | null = null

    constructor() {
        super()
        this.grid = new Grid<PartsFluidsItem>(this.services)
            .isReadOnly(true)
            .wrapColumnHeaders()
            .doInitialSelection(false)
            .filterBy(item => [item.source, item.category, item.subCategory, item.itemLabel, item.itemValue, item.details, item.notes])

        effect(() => {
            const equipment = this.selectedEquipment()
            this.loadItems(equipment)
        })

        effect(() => {
            const equipment = this.selectedEquipment()
            this.equipmentOptions()
            this.applyEquipmentToCombo(equipment)
        })
    }

    onEquipmentComboInitialized(combo: ComboBox) {
        this.equipmentCombo = combo
        this.applyEquipmentToCombo(this.selectedEquipment())
    }

    onEquipmentComboChange() {
        if (this.applyingSelection) return
        const next = (this.equipmentCombo?.selectedValue as string) ?? ''
        if (!next || next === (this.selectedEquipment() ?? '')) return
        this.selectedEquipmentChange.emit(next)
    }

    loadItems(equipment: string) {
        if (equipment === this.lastLoadedEquipment) return
        this.lastLoadedEquipment = equipment

        if (!equipment) {
            this.grid.items = []
            this.initialLoadingComplete()
            return
        }

        const params = new HttpParams().set('equipment', equipment)
        this.cancelableRequest(
            'forEquipment',
            true,
            this.services.data.get<PartsFluidsItem[]>('api/EquipmentPartsFluidsLookup/ForEquipment', params).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.grid.items = result ?? []
                },
            }),
        )
    }

    private applyEquipmentToCombo(equipment: string) {
        const combo = this.equipmentCombo
        if (!combo) return

        const apply = () => {
            this.applyingSelection = true
            const options = this.equipmentOptions()
            const target = (equipment ?? '').trim()
            const index = options.findIndex(x => (x.value ?? '').trim() === target)
            if (index >= 0) {
                combo.selectedIndex = index
                combo.selectedValue = options[index].value
                combo.text = options[index].display
            } else if (!target) {
                combo.selectedIndex = -1
            }
            setTimeout(() => {
                this.applyingSelection = false
            })
        }

        apply()
        setTimeout(apply)
    }
}
